import apps from '~/sagas/apps/apps.saga';

export default apps;
